import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button, Card, Form } from "react-bootstrap";
import ConfirmModal from "../ConfirmModal";
import TableForm from "../TableForm";
import SearchFilter from "../SearchFilter";

const StatusSparepartCommandForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const defaultData = {
    Plan_Std_Status: null,
    Com_Code: user.Com_Code
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const searchInput = [
    {
      name: "Item_Code",
      label: "รหัสสินค้า",
      type: "text",
      disabled: true,
      value: ""
    },
    {
      name: "Item_Name",
      label: "ชื่อสินค้า",
      type: "text",
      disabled: true,
      value: ""
    }
  ];
  const inputField = [
    { name: "Item_Code", label: "รหัสสินค้า", type: "text", readOnly: true },
    { name: "Item_Model", label: "Model Number", type: "text", readOnly: true },
    { name: "Item_Bar", label: "บาร์โคด", type: "text", readOnly: true },
    { name: "Plan_Std_Status", label: "สถานะ", type: "select", options: [] }
  ];

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Array[0]);
    }
  };

  useEffect(() => {
    if (editData) {
      setData({
        Array: [
          {
            Plan_Std_Status: editData.Plan_Std_Status,
            Com_Code: user.Com_Code
          }
        ]
      });
    }
  }, [editData]);

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 border-bottom-0 bg-transparent">
          <Card.Title className="mb-3 fs-2 text-center">ค้นหาลูกค้า</Card.Title>
        </Card.Header>

        <Card.Body>
          <SearchFilter data={data.Array} inputField={searchInput} />
        </Card.Body>
      </Card>

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <TableForm
              data={data.Array}
              columns={inputField}
              editForm={!!editData}
              onChangeCallback={(newData) => setData({ Array: newData })}
              defaultData={defaultData}
            />
          </Card.Body>

          <Card.Footer className="p-3 text-end border-top-0 bg-transparent">
            <Button
              type="submit"
              variant="success"
              className="px-5 py-2 text-dark rounded-pill"
            >
              {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
            </Button>
            <ConfirmModal
              show={showModal}
              data={data}
              content={editData ? "edit" : "save"}
              onSubmitCallback={handleSubmit}
            />

            <Button
              variant="outline-success"
              className="px-5 py-2 text-dark border-secondary rounded-pill"
              onClick={() => navigate(-1)}
            >
              ยกเลิก
            </Button>
          </Card.Footer>
        </Card>
      </Form>
    </>
  );
};

StatusSparepartCommandForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default StatusSparepartCommandForm;
